import { gql } from '@apollo/client'

export const GET_BUILDING_ID = gql`
  query BuildingGetId($where: BuildingWhereUniqueSearchOneInput!) {
    buildingGetOne(where: $where) {
      id
      name
    }
  }
`

export const GET_CHANNEL_SEARCH_MANY = gql`
  query ChannelSearchMany($where: ChannelSearchManyInput!) {
    channelSearchMany(where: $where) {
      id
      createdAt
      updatedAt
      name
      reference
      period
      incomingUnit
      measurementType
      buildingId
      parentId
      channelType
      isDisabled
      channelIssues {
        lastSeen
        isImportant
        notTransmitting
        notCumulative
        includesZeroes
        isDisabled
      }
    }
  }
`

export const GET_COMBI_CHANNELS = gql`
  query CompositeChannelRelationships($where: CompositeChannelGetManyInput!) {
    compositeChannelRelationships(where: $where) {
      name
      id
      composite
      isDashboardDefault
      children {
        name
        id
        composite
        isDashboardDefault
        children {
          name
          id
          composite
          isDashboardDefault
          children {
            name
            id
            composite
            isDashboardDefault
            children {
              name
              id
              composite
              isDashboardDefault
              children {
                name
                id
                composite
                isDashboardDefault
              }
            }
          }
        }
      }
    }
  }
`

export const GET_RELATIONSHIP_TREE = gql`
  query ChannelMeterRelationships($where: SearchChannelByBuildingIdInput!) {
    channelMeterRelationships(where: $where) {
      id
      createdAt
      updatedAt
      name
      reference
      period
      incomingUnit
      measurementType
      buildingId
      parentId
      channelType
      channelIssues {
        lastSeen
        isImportant
        notTransmitting
        notCumulative
        includesZeroes
        isDisabled
      }
      children {
        id
        createdAt
        updatedAt
        name
        reference
        period
        measurementType
        buildingId
        parentId
        channelType
        channelIssues {
          lastSeen
          isImportant
          notCumulative
          includesZeroes
          isDisabled
        }
        children {
          id
          createdAt
          updatedAt
          name
          reference
          period
          measurementType
          buildingId
          parentId
          channelType
          channelIssues {
            lastSeen
            isImportant
            notTransmitting
            notCumulative
            includesZeroes
            isDisabled
          }
          children {
            id
            createdAt
            updatedAt
            name
            reference
            period
            measurementType
            buildingId
            parentId
            channelType
            channelIssues {
              lastSeen
              isImportant
              notTransmitting
              notCumulative
              includesZeroes
              isDisabled
            }
            children {
              id
              createdAt
              updatedAt
              name
              reference
              period
              measurementType
              buildingId
              parentId
              channelType
              channelIssues {
                lastSeen
                isImportant
                notTransmitting
                notCumulative
                includesZeroes
                isDisabled
              }
              children {
                id
                createdAt
                updatedAt
                name
                reference
                period
                measurementType
                buildingId
                parentId
                channelType
                channelIssues {
                  lastSeen
                  isImportant
                  notTransmitting
                  notCumulative
                  includesZeroes
                  isDisabled
                }
              }
            }
          }
        }
      }
    }
  }
`

export const GET_ONE_COMBI = gql`
  query GetOneCompositeChannel($where: CompositeChannelGetOneInput!) {
    getOneCompositeChannel(where: $where) {
      id
      createdAt
      updatedAt
      name
      buildingId
      channelList
      period
      shadowId
      isDashboardDefault
      incomingUnit
    }
  }
`

export const GET_TARGETS = gql`
  query Targets($where: TargetGetManyInput!) {
    targets(where: $where) {
      id
      createdAt
      updatedAt
      name
      period
      benchmark
      channelId
      targetValue
      triggerCondition
      nextExpectedTime
      lastComparisonTime
      lastComparisonValue
    }
  }
`

export const GET_ALERTS = gql`
  query Alerts($where: AlertGetManyInput!) {
    alerts(where: $where) {
      id
      createdAt
      updatedAt
      userId
      targetId
      destination
      messageType
      severity
    }
  }
`
export const GET_BUILDINGS = gql`
  query BuildingGetMany($where: BuildingWhereUniqueSearchManyInput!) {
    buildingGetMany(where: $where) {
      id
      name
      defaultName
      projectRef
      slug
      picture
      thumb
      epcRating
      epcUrl
      breeamRating
      breeamScore
      constructionYear
      floorArea
      hasFileServer
      hasDataServer
      dashboardPeriod
      dashboardStyle
      lastSeen
      buildingTransmitting
      isOccupied
      isSubscribedDatalake
      isSubscribedOptitwin
      channelIssues {
        channelId
        lastSeen
        isImportant
        notTransmitting
        notCumulative
        includesZeroes
        isDisabled
      }
      mqttInfo {
        mqttUsername
        mqttPassword
      }
      uploadConfig {
        ftpConfig {
          id
          buildingId
          connectionType
          parser
        }
        mqttConfig {
          id
          buildingId
          connectionType
          host
          password
          port
          protocol
          topic
          useDefaultServer
          username
        }
      }
      companyRelationships {
        companyId
        companyName
        buildingName
        companyReference
        companyReferenceName
        relationshipType
      }
      address {
        buildingId
        companyId
        firstLine
        secondLine
        city
        region
        country
        postcode
        latitude
        longitude
        gasRegion
      }
      portfolio {
        renewables {
          measurement
          target
          unit
        }
        waterUsage {
          measurement
          target
          unit
        }
        carbonDioxide {
          measurement
          target
          unit
        }
        wholeBuilding {
          measurement
          target
          unit
        }
      }
    }
  }
`

export const GET_COMPANY = gql`
  query Company($where: CompanyWhereUnique!) {
    company(where: $where) {
      name
      portfolioImage
      slug
      logo
    }
  }
`

export const ME_QUERY = gql`
  query Me {
    me {
      token
    }
  }
`
export const RESET_EMAIL_TOEKN_QUERY = gql`
  query checkResetToken($where: String!) {
    checkResetToken(where: $where) {
      isValid
      email
    }
  }
`
export const GET_BUILDING = gql`
  query BuildingGetOne($where: BuildingWhereUniqueSearchOneInput!) {
    buildingGetOne(where: $where) {
      id
      name
      defaultName
      projectRef
      slug
      picture
      thumb
      epcRating
      epcUrl
      breeamRating
      breeamScore
      constructionYear
      floorArea
      hasFileServer
      hasDataServer
      dashboardPeriod
      dashboardStyle
      lastSeen
      buildingTransmitting
      tryMessage
      infoMessage
      isOccupied
      isSubscribedDatalake
      isSubscribedOptitwin
      channelIssues {
        channelId
        lastSeen
        isImportant
        notTransmitting
        notCumulative
        includesZeroes
        isDisabled
      }
      mqttInfo {
        mqttUsername
        mqttPassword
      }
      uploadConfig {
        ftpConfig {
          id
          buildingId
          connectionType
          parser
        }
        mqttConfig {
          id
          buildingId
          connectionType
          host
          password
          port
          protocol
          topic
          useDefaultServer
          username
        }
      }
      companyRelationships {
        companyId
        buildingId
        companyName
        buildingName
        companyReference
        companyReferenceName
        relationshipType
      }
      address {
        buildingId
        companyId
        firstLine
        secondLine
        city
        region
        country
        postcode
        latitude
        longitude
        gasRegion
      }
      portfolio {
        renewables {
          measurement
          target
          comment
          comparison
          unit
        }
        waterUsage {
          measurement
          target
          comment
          comparison
          unit
        }
        carbonDioxide {
          measurement
          target
          comment
          comparison
          unit
        }
        wholeBuilding {
          measurement
          target
          comment
          comparison
          unit
        }
        heatingEnergy {
          measurement
          target
          comment
          comparison
          unit
        }
        coolingEnergy {
          measurement
          target
          comment
          comparison
          unit
        }
        processEnergy {
          measurement
          target
          comment
          comparison
          unit
        }
        socketPower {
          measurement
          target
          comment
          comparison
          unit
        }
        lightingEnergy {
          measurement
          target
          comment
          comparison
          unit
        }
        ventilation {
          measurement
          target
          comment
          comparison
          unit
        }
      }
    }
  }
`

export const GET_COMPANIES = gql`
  query Companies($where: CompanyWhereSearch!) {
    companies(where: $where) {
      id
      createdAt
      updatedAt
      name
      slug
      portfolioImage
      logo
      primaryColor
      secondaryColor
      fontColor
      userIds
    }
  }
`

export const GET_CHANNEL_DATA = gql`
  query DataGetMany($where: DataInput!) {
    dataGetMany(where: $where) {
      id
      name
      unit
      data {
        id
        channelId
        timestamp
        value
        status
      }
    }
  }
`

export const GET_DASHBOARD_SLUG = gql`
  query Dashboard($where: DashboardInput!) {
    dashboard(where: $where) {
      id
      createdAt
      updatedAt
      buildingId
      buildingName
      occupierLogo
      dashboardStyle
      renewables {
        measurement
        target
        comment
        comparison
        unit
      }
      carbonDioxide {
        measurement
        target
        comment
        comparison
        unit
      }
      waterUsage {
        measurement
        target
        comment
        comparison
        unit
      }
      wholeBuilding {
        measurement
        target
        comment
        comparison
        unit
      }
      ventilation {
        measurement
        target
        comment
        comparison
        unit
      }
      coolingEnergy {
        measurement
        target
        comment
        comparison
        unit
      }
      heatingEnergy {
        measurement
        target
        comment
        comparison
        unit
      }
      lightingEnergy {
        measurement
        target
        comment
        comparison
        unit
      }
      socketPower {
        measurement
        target
        comment
        comparison
        unit
      }
      processEnergy {
        measurement
        target
        comment
        comparison
        unit
      }
      period
      dashboardColors {
        primaryColor
        secondaryColor
        fontColor
      }
      tryMessage
      infoMessage
      currentConsumption
      currentGeneration
      lifetimeCarbonSavings
      lifetimeCarbonSavingsUnits
      address {
        companyId
        city
        postcode
        latitude
        longitude
      }
      weatherAPI {
        key
        host
      }
      transportAPI {
        id
        key
      }
    }
  }
`
export const GET_USERS = gql`
  query UserGetMany($where: UserGetManyInput!) {
    userGetMany(where: $where) {
      id
      createdAt
      updatedAt
      companyId
      email
      firstName
      lastName
      slug
      picture
      role
      customPermissions
    }
  }
`
export const GET_COMPANIES_LIST = gql`
  query CompanyList($where: CompanyWhereSearch!) {
    companies(where: $where) {
      id
      name
    }
  }
`

export const EMAIL_BUILDING_OVERVIEW = gql`
  query EmailBuildingOverview($where: EmailBuildingOverviewInput!) {
    emailBuildingOverview(where: $where) {
      result
    }
  }
`

export const EMAIL_FULL_BUILDING = gql`
  query EmailFullBuilding($where: EmailFullBuildingInput!) {
    emailFullBuilding(where: $where) {
      result
    }
  }
`

export const GET_COMBI_CHANNELS_LIST = gql`
  query GetManyCompositeChannel($where: CompositeChannelGetManyInput!) {
    getManyCompositeChannel(where: $where) {
      id
      createdAt
      updatedAt
      name
      buildingId
      channelList
      period
      shadowId
      incomingUnit
    }
  }
`

export const GET_INSPECTOR = gql`
  query InspectorGetOne($where: InspectorGetOneInput!) {
    inspectorGetOne(where: $where) {
      id
      createdAt
      updatedAt
      buildingId
      buildingLastSeen
      buildingTransmitting
      channels {
        lastSeen
        channelId
        isImportant
        notCumulative
        includesZeroes
        notTransmitting
        isDisabled
      }
    }
  }
`
export const GET_TARGET_ALERTS = gql`
  query TargetAlertsGetMany($where: TargetGetManyInput!) {
    targetAlertsGetMany(where: $where) {
      name
      benchmark
      channelId
      triggerCondition
      isDashboardDefault
      severity
      daily {
        targetId
        targetValue
        alertId
      }
      weekly {
        targetId
        targetValue
        alertId
      }
      monthly {
        targetId
        targetValue
        alertId
      }
      yearly {
        targetId
        targetValue
        alertId
      }
    }
  }
`

export const GET_GAS_CALORIES = gql`
  query GasCaloriesGetAll {
    gasCaloriesGetAll {
      id
      country
      region
      date
      value
    }
  }
`

export const GET_GAS_CARBON = gql`
  query GasCarbonGetAll {
    gasCarbonGetAll {
      id
      country
      date
      value
    }
  }
`

export const GET_ELECTRICITY_CARBON = gql`
  query ElectricityCarbonGetAll {
    electricityCarbonGetAll {
      id
      country
      date
      value
    }
  }
`

export const GET_DATA_IN_BINS = gql`
  query DataGetManyInBins($where: DataInBinsInput!) {
    dataGetManyInBins(where: $where) {
      date
      bins {
        id
        timestamp
        value
        status
        channelId
      }
    }
  }
`

export const GET_BUILDING_ADDRESS = gql`
  query BuildingGetAddress($where: BuildingWhereUniqueSearchManyInput!) {
    buildingGetMany(where: $where) {
      id
      name
      address {
        buildingId
        postcode
        latitude
        longitude
      }
    }
  }
`

export const GET_ONE_USER = gql`
  query UserGetOne($where: UserGetOneInput!) {
    userGetOne(where: $where) {
      email
      firstName
      lastName
      picture
      id
      reporting {
        id
        userId
        portfolioEnabled
        portfolioPeriod
        buildings {
          buildingId
          buildingName
          buildingEnabled
          buildingPeriod
        }
      }
    }
  }
`
